import { Link } from 'react-router-dom';
import ShellHeader from './ShellHeader';
import { hubGames } from '../hubGames';

const pageMap = {
  hub: {
    title: 'stans-world',
  },
  profile: {
    title: 'Profile',
  },
  settings: {
    title: 'Settings',
  },
};

const FEATURED_SLOTS = 3;
const CATALOG_PLACEHOLDER_COUNT = 5;

function PageView({ tab }) {
  const page = pageMap[tab] ?? pageMap.hub;
  const isHub = tab === 'hub';
  const featured = hubGames.filter((g) => g.featured);
  const featuredFill = Math.max(0, FEATURED_SLOTS - featured.length);

  return (
    <main className="page-view">
      <ShellHeader tab={tab} />

      {isHub ? (
        <section className="hub-skeleton" aria-label="Mini-game hub">
          <div className="hub-section hub-section--first">
            <h2>Featured Games</h2>
            <div className="hub-grid hub-grid--featured">
              {featured.map((g) => (
                <Link
                  key={g.slug}
                  className="hub-game-card hub-game-card--primary"
                  to={`/games/${g.slug}`}
                >
                  <span className="hub-game-card__title">{g.title}</span>
                  <span className="hub-game-card__hint">{g.hint}</span>
                </Link>
              ))}
              {Array.from({ length: featuredFill }).map((_, i) => (
                <div key={`feat-sk-${i}`} className="skeleton-block skeleton-card" aria-hidden />
              ))}
            </div>
          </div>

          <div className="hub-section">
            <h2>All Mini-Games</h2>
            <div className="hub-grid hub-grid--catalog">
              {hubGames.map((g) => (
                <Link
                  key={g.slug}
                  className="hub-game-card hub-game-card--catalog"
                  to={`/games/${g.slug}`}
                >
                  <span className="hub-game-card__title">{g.title}</span>
                  <span className="hub-game-card__hint">{g.hint}</span>
                </Link>
              ))}
              {Array.from({ length: CATALOG_PLACEHOLDER_COUNT }).map((_, i) => (
                <div key={`cat-sk-${i}`} className="skeleton-block skeleton-card" aria-hidden />
              ))}
            </div>
          </div>
        </section>
      ) : (
        <section className="plain-page-placeholder" aria-label={`${page.title} placeholder`}>
          <h2>{page.title}</h2>
        </section>
      )}
    </main>
  );
}

export default PageView;
